import auth from "../../middlewares/auth";

export const sshKeypairRoutes = [
    {
        path: '/ssh-key',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/sshKeypair/SshKeyPairIndex.vue'),
        name: 'ssh_key',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/ssh-terminal',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/ssh_terminal/SshTerminal.vue'),
        name: 'ssh_terminal',
        meta: {
            middleware: [
                auth
            ]
        }
    }
]